import { MembershipSummaryDto } from '../../../types';

interface StatsPanelProps {
  data: MembershipSummaryDto;
  showInvolvementBreakdown: boolean;
}

const ALL_LEAD_ROLES = [
  'Lead',
  'Community Lead',
  'Executive Champion',
  'HR Support Lead',
  'Adviser',
];

export function StatsPanel({ data, showInvolvementBreakdown }: StatsPanelProps) {
  // Ensure all 8 lead roles always display, even with 0 count
  const leadRolesMap = new Map(data.leadRoles.map((r) => [r.roleName, r.count]));

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
      }}
    >
      {/* Total Engaged Employees - Gradient Box */}
      <div
        style={{
          background: 'linear-gradient(135deg, #5b6abf 0%, #7b8ed6 100%)',
          color: '#fff',
          padding: '20px',
          borderRadius: '8px',
        }}
      >
        <div style={{ fontSize: '2.5rem', fontWeight: 700, lineHeight: 1, color: '#90ee90' }}>
          {data.totalEngagedEmployees.toLocaleString()}
        </div>
        <div style={{ fontSize: '0.8rem', marginTop: '10px', opacity: 0.9 }}>
          Total engaged employees
        </div>
        <div style={{ fontSize: '0.7rem', marginTop: '2px', opacity: 0.7 }}>
          (unique records)
        </div>
      </div>

      {/* Involvement Breakdown - only show when "All BRGs" is selected */}
      {showInvolvementBreakdown && (
        <div style={{ backgroundColor: '#f5f5f5', padding: '16px', borderRadius: '4px' }}>
          <div style={{ fontSize: '0.75rem', fontWeight: 600, color: '#666', marginBottom: '12px' }}>
            Number of employees involved in:
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem' }}>
              <span>1 BRG</span>
              <span style={{ fontWeight: 600, color: '#0078d4' }}>{data.in1Brg}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem' }}>
              <span>2 BRGs</span>
              <span style={{ fontWeight: 600, color: '#0078d4' }}>{data.in2Brgs}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem' }}>
              <span>3 BRGs</span>
              <span style={{ fontWeight: 600, color: '#0078d4' }}>{data.in3Brgs}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem' }}>
              <span>4 BRGs</span>
              <span style={{ fontWeight: 600, color: '#0078d4' }}>{data.in4Brgs}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem' }}>
              <span>5+ BRGs</span>
              <span style={{ fontWeight: 600, color: '#0078d4' }}>{data.in5OrMoreBrgs}</span>
            </div>
          </div>
        </div>
      )}

      {/* Lead Roles Breakdown */}
      <div
        style={{
          backgroundColor: '#f9f9fb',
          padding: '16px',
          borderRadius: '4px',
          borderLeft: '4px solid #5b6abf',
        }}
      >
        <div style={{ fontSize: '0.8rem', fontWeight: 600, color: '#333', marginBottom: '12px' }}>
          Number of employees in lead roles:
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {ALL_LEAD_ROLES.map((roleName) => (
            <div key={roleName} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem' }}>
              <span>{roleName}</span>
              <span style={{ fontWeight: 600 }}>{leadRolesMap.get(roleName) ?? 0}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
